<template>
  <el-form :model="projectForm" :rules="rules" ref="projectForm" label-width="100px" class="demo-projectForm">
    <el-form-item label="项目名称" prop="project_name">
      <el-input v-model="projectForm.project_name" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="项目slug" prop="slug">
      <el-input v-model="projectForm.slug" placeholder="请输入项目slug"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('projectForm')">立即创建</el-button>
      <el-button @click="resetForm('projectForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { medusaApi } from '@/api/index';
let validateSlug = (rule, value, callback) => {
  if (!/^[A-Za-z_-]+$/.test(value)) {
    callback(new Error('slug不能是英文,-,_之外的字符'))
  } else if (value.length > 40) {
    callback(new Error('slug长度不能超过40位'))
  } else if (value.trim() === '') {
    callback(new Error('slug不能为空'))
  } else {
    callback()
  }
}
export default {
  data () {
    return {
      projectForm: {
        project_name: '',
        slug: ''
      },
      rules: {
        project_name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        slug: [
          {
            required: true, message: 'slug不能为空', trigger: 'blur'
          },
          { validator: validateSlug, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await medusaApi.createProject(this.projectForm);
          if (res.code) {
            this.$message.success('创建成功！');
            this.$emit('close');
            this.$emit('getProjects');
          } else {
            this.$message.error(res.message);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style>
</style>